<template>
  <v-dialog
      v-model="show"
      :max-width="'450px'"
      persistent
      style="z-index: 2002"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Fehlzeit wählen</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row style="margin: 0">
              <p style="padding-top: 12px; margin-top: 12px; margin-left: 8px; padding-bottom: 0px;
    font-size: 0.875rem;
    font-weight: 500;
    justify-content: center;
    letter-spacing: 0.0892857143em;
    line-height: normal; color: rgba(0, 0, 0, 0.87);">Fehlzeiten</p>
              <v-spacer></v-spacer>
              <v-text-field
                  v-model="search_fehl"
                  prepend-icon="mdi-magnify"
                  label="Suchen"
                  single-line
                  hide-details
                  clearable
              ></v-text-field>
            </v-row>
            <v-list                 style="max-height: 45vh; min-height: 45vh; overflow-y: auto"
            >
              <v-list-item-group
                  v-model="selectedFehl"
                  color="indigo"
              >
                <v-list-item
                    v-for="(item, i) in filteredFehls"
                    :key="item.id"
                    :value="item.id"
                    style="border-bottom: rgba(128,128,128,0.25) thin solid;"
                >
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12">
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            v-on:click.stop="show = false"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            :disabled="selectedFehl === null"
            v-on:click.stop="sendResult"
        >
          Auswählen
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: "SelectFehlDialog",
  props: {
    currentMita: {
      type: Object,
      default: () => undefined
    },
    fehls: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    selectedFehl: null,
    show: false,
    search_fehl: '',
  }),
  computed: {
    filteredFehls() {
      let res =  [...this.fehls];
      res.sort((a, b) => a.name.localeCompare(b.name));
      if (this.search_fehl && this.search_fehl.length > 0) {
        const search = this.search_fehl.toLowerCase();
        res = res.filter(fehl => fehl.name.toLowerCase().includes(search));
      }
      return res;
    },
  },
  methods: {
    sendResult() {
      this.$emit('selected-fehl', this.fehls.find(f => f.id === this.selectedFehl));
      this.show = false;
    },
    openDialog() {
      this.selectedFehl = null;
      console.log(this.fehls)
      this.show = true;
    },
  }
}
</script>

<style scoped>

::v-deep .v-list-item__content {
  padding: 0px 0;
}

::v-deep .v-list-item {
  min-height: 34px;
}

::v-deep .v-subheader {
  height: 24px;
  font-weight: 500;
}

::v-deep .v-divider {
  margin-bottom: 6px;
  margin-top: 6px;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > .v-data-table__expanded__row > td {
  border: none !important;
}

::v-deep .test-start:has(> .v-data-table__expanded__row) {
  border: none;
}

::v-deep .v-data-table__expanded__content {
  box-shadow: none !important;
  cursor: pointer;
}

::v-deep  .v-data-table__expanded__row {
  background-color: white !important;
}

.message-memo {
  -webkit-font-smoothing: antialiased;
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: .875rem;
  letter-spacing: normal;
  color: #5f6368;
  font-weight: normal;
  vertical-align: sub;
}

::v-deep .month-picker-input {
  padding: 0.25rem 0.5rem;
  font-size: 0.765625rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  width: 140px;
}

::v-deep .v-data-table__wrapper {
  min-height: 39vh;
}

</style>
